    <div class="pub-community-card-item-container p-3 bg-white" [ngClass]="{'show-view-all justify-content-center': isViewAll}" [id]="'PUBLIC_COMMUNITIES_CARD-' + pCommunity?.da_id">
        <ng-container *ngIf="!isViewAll; else viewAll">
            <div class="card-container cursor-pointer" (click)="navigateToDetailHandler()">
                <div class="banner-container">
                    <img loading="lazy" [src]="pCommunity?.media_list[0]?.media_url"
                        onerror="this.src='assets/themes/icons/banner-placeholder.svg'"
                        alt="public community banner"
                        class="banner-img mb-3 post-pic" />
                    <img *ngIf="pCommunity?.pulsating_post === numbers.ONE && carouselType === carousel.MY_COMMUNITY_CAROUSEL " class="pulse-icon" src="assets/images/icons/Pulsating-icon.gif" alt="pulsating-icon">
                </div>
                <span class="heading-4 mb-2 title" [id]="'PUBLIC_COMMUNITIES_CARD_NAME-' + pCommunity?.da_id">{{pCommunity?.title}}</span>
                <span class="secondary-paragraph created-by ellipsis"><span class="color-grey-500" [id]="'PUBLIC_COMMUNITIES_CARD_CREATED_BY_NAME-' + pCommunity?.da_id">{{mls.languageText.community.key9}} {{pCommunity?.created_by?.full_name}}</span></span>
            </div>
            <button *ngIf="pCommunity?.flags?.show_join_button === numbers.ONE || screenFrom === callFrom && carouselType !== carousel.MY_COMMUNITY_CAROUSEL"
              class="btn-design outline medium w-100 request-btn h-auto"
              [class]="withdrawRequest || pCommunity?.request?.response === numbers.TWO ? 'outline' : (pCommunity?.flags?.is_active !== isCommunityActive && (callingFrom !== '')? 'outline-disabled' :'')"
              (click)="joinCommunity()">
                <img src="assets/themes/icons/primary-loader.gif" width="20" height="20"
                    class="cursor-pointer loading"
                    *ngIf="loader"
                    alt="loader"/>
                {{cardActionText}}
            </button>
            <button *ngIf="carouselType === carousel.MY_COMMUNITY_CAROUSEL"
               class="btn-design outline medium w-100 view-community"
               (click)="navigateToDetail()" >
               {{mls.languageText.community.key152}}
           </button>
        </ng-container>
    </div>

    <ng-template #viewAll>
        <div class="view-all-container d-flex cursor-pointer align-items-center justify-content-center" (click)="viewAllHandler()">
            <span class="paragraph">{{mls.languageText.community.key10}}</span>
            <img src="assets/themes/icons/right-arrow-head.svg"
                alt="right nav"
                class="ml-2 nav-icon"/>
        </div>
    </ng-template>
